import React, { useState } from 'react';

export default function ResetBankModal({
  open,
  onCancel,
  onConfirm,
  title = 'Remove bank account?',
  description = 'This removes the bank account on file. You will need to add payout details again before we can pay you.',
  confirmLabel = 'Remove account',
}) {
  const [submitting, setSubmitting] = useState(false);

  if (!open) return null;

  const handleConfirm = async () => {
    setSubmitting(true);
    try {
      await onConfirm();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="reset-modal-backdrop"
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget && !submitting) onCancel();
      }}
    >
      <div
        className="reset-modal"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="reset-bank-title"
        aria-describedby="reset-bank-desc"
      >
        <div className="reset-modal__icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M12 9v4m0 4h.01M10.29 3.86l-8.18 14.18A2 2 0 0 0 3.82 21h16.36a2 2 0 0 0 1.71-3.96L13.71 3.86a2 2 0 0 0-3.42 0Z"
              stroke="#D64545"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h3 id="reset-bank-title" className="reset-modal__title">
          {title}
        </h3>
        <p id="reset-bank-desc" className="reset-modal__desc">
          {description}
        </p>
        <div className="reset-modal__actions">
          <button
            type="button"
            className="reset-modal__btn reset-modal__btn--ghost"
            onClick={onCancel}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="reset-modal__btn reset-modal__btn--danger"
            onClick={handleConfirm}
            disabled={submitting}
          >
            {submitting ? (
              <span className="reset-modal__spinner" aria-label="Removing" />
            ) : (
              confirmLabel
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
